import pixelThemeCss from '@yakiniku/core/pixelTheme.sass?inline'

export type DemoVisualTheme = 'modern' | 'pixel'

const storageKey = 'yakiniku-demo-visual-theme'
const pixelThemeStyleId = 'yakiniku-demo-pixel-theme'

export const isDemoVisualTheme = (
	value: string | null
): value is DemoVisualTheme => value === 'modern' || value === 'pixel'

export const getInitialDemoVisualTheme = (): DemoVisualTheme => {
	const urlTheme = new URLSearchParams(window.location.search).get('theme')
	if (isDemoVisualTheme(urlTheme)) {
		return urlTheme
	}

	const storedTheme = window.localStorage.getItem(storageKey)
	if (isDemoVisualTheme(storedTheme)) {
		return storedTheme
	}

	return 'pixel'
}

export const applyDemoVisualTheme = (theme: DemoVisualTheme) => {
	const existingStyle = document.getElementById(pixelThemeStyleId)

	if (theme === 'modern') {
		existingStyle?.remove()
	} else if (!existingStyle) {
		const style = document.createElement('style')
		style.id = pixelThemeStyleId
		style.textContent = pixelThemeCss
		document.head.append(style)
	}

	document.documentElement.dataset.yakinikuDemoTheme = theme
	window.localStorage.setItem(storageKey, theme)
}
